import * as React from 'react';
import './InputIcon.css';
var INPUT_ICON_SPACING = '22px';
function getLeft(size, width, position) {
  if (position === 'left') {
    return '0.25em';
  } else if (size === 'small') {
    return "calc(100% - ".concat(INPUT_ICON_SPACING, ")");
  } else {
    return "calc(".concat(width || '23em', " - ").concat(INPUT_ICON_SPACING, ")");
  }
}
export default function InputIcon(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'left' : _ref$position,
    size = _ref.size,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "_dm-input__icon",
    style: {
      left: getLeft(size, width, position)
    },
    "aria-hidden": "true"
  }, icon);
}